import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import './linesDecorations.css';
import { DecorationToRender, DedupOverlay } from '../glyphMargin/glyphMargin.js';
export var LinesDecorationsOverlay = /*#__PURE__*/function (_DedupOverlay) {
  _inherits(LinesDecorationsOverlay, _DedupOverlay);

  var _super = _createSuper(LinesDecorationsOverlay);

  function LinesDecorationsOverlay(context) {
    var _this;

    _classCallCheck(this, LinesDecorationsOverlay);

    _this = _super.call(this);
    _this._context = context;
    var options = _this._context.configuration.options;
    var layoutInfo = options.get(117
    /* layoutInfo */
    );
    _this._decorationsLeft = layoutInfo.decorationsLeft;
    _this._decorationsWidth = layoutInfo.decorationsWidth;
    _this._renderResult = null;

    _this._context.addEventHandler(_assertThisInitialized(_this));

    return _this;
  }

  _createClass(LinesDecorationsOverlay, [{
    key: "dispose",
    value: function dispose() {
      this._context.removeEventHandler(this);

      this._renderResult = null;

      _get(_getPrototypeOf(LinesDecorationsOverlay.prototype), "dispose", this).call(this);
    } // --- begin event handlers

  }, {
    key: "onConfigurationChanged",
    value: function onConfigurationChanged(e) {
      var options = this._context.configuration.options;
      var layoutInfo = options.get(117
      /* layoutInfo */
      );
      this._decorationsLeft = layoutInfo.decorationsLeft;
      this._decorationsWidth = layoutInfo.decorationsWidth;
      return true;
    }
  }, {
    key: "onDecorationsChanged",
    value: function onDecorationsChanged(e) {
      return true;
    }
  }, {
    key: "onFlushed",
    value: function onFlushed(e) {
      return true;
    }
  }, {
    key: "onLinesChanged",
    value: function onLinesChanged(e) {
      return true;
    }
  }, {
    key: "onLinesDeleted",
    value: function onLinesDeleted(e) {
      return true;
    }
  }, {
    key: "onLinesInserted",
    value: function onLinesInserted(e) {
      return true;
    }
  }, {
    key: "onScrollChanged",
    value: function onScrollChanged(e) {
      return e.scrollTopChanged;
    }
  }, {
    key: "onZonesChanged",
    value: function onZonesChanged(e) {
      return true;
    } // --- end event handlers

  }, {
    key: "_getDecorations",
    value: function _getDecorations(ctx) {
      var decorations = ctx.getDecorationsInViewport();
      var r = [],
          rLen = 0;

      for (var i = 0, len = decorations.length; i < len; i++) {
        var d = decorations[i];
        var linesDecorationsClassName = d.options.linesDecorationsClassName;

        if (linesDecorationsClassName) {
          r[rLen++] = new DecorationToRender(d.range.startLineNumber, d.range.endLineNumber, linesDecorationsClassName);
        }

        var firstLineDecorationClassName = d.options.firstLineDecorationClassName;

        if (firstLineDecorationClassName) {
          r[rLen++] = new DecorationToRender(d.range.startLineNumber, d.range.startLineNumber, firstLineDecorationClassName);
        }
      }

      return r;
    }
  }, {
    key: "prepareRender",
    value: function prepareRender(ctx) {
      var visibleStartLineNumber = ctx.visibleRange.startLineNumber;
      var visibleEndLineNumber = ctx.visibleRange.endLineNumber;

      var toRender = this._render(visibleStartLineNumber, visibleEndLineNumber, this._getDecorations(ctx));

      var left = this._decorationsLeft.toString();

      var width = this._decorationsWidth.toString();

      var common = '" style="left:' + left + 'px;width:' + width + 'px;"></div>';
      var output = [];

      for (var lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++) {
        var lineIndex = lineNumber - visibleStartLineNumber;
        var classNames = toRender[lineIndex];
        var lineOutput = '';

        for (var i = 0, len = classNames.length; i < len; i++) {
          lineOutput += '<div class="cldr ' + classNames[i] + common;
        }

        output[lineIndex] = lineOutput;
      }

      this._renderResult = output;
    }
  }, {
    key: "render",
    value: function render(startLineNumber, lineNumber) {
      if (!this._renderResult) {
        return '';
      }

      return this._renderResult[lineNumber - startLineNumber];
    }
  }]);

  return LinesDecorationsOverlay;
}(DedupOverlay);